<template>
  <VuePerfectScrollbar>
    <div
      id="groovemail-server-table-view"
      class="p-6 groovemail-table-common groovemail-opens-clicks-table relative"
    >
      <v-server-table
        ref="clicksTable"
        name="ClicksTable"
        :columns="clicksDataColumns"
        :url="clicksUrl"
        :options="clicksDataOptions"
        class="text-center"
        @loaded="hideLoader()"
        @loading="showLoader()"
      >
      </v-server-table>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  name: 'broadcast-clicks',

  props: {
    clicksUrl: {
      required: true,
    },
  },

  mixins: [demoModeValuesMixin],

  data() {
    return {
      clicksDataColumns: ['first_name', 'last_name', 'email', 'redirect_url'],
      clicksDataOptions: {
        perPage: 5,
        debounce: 1000,
        perPageValues: [5],
        pagination: { chunk: 5 },
        requestFunction(data) {
          const self = this;
          const customUrl = self.url.split('?');
          const campaignId = customUrl[1].split('=')[1];
          return axios
            .post(
              customUrl[0],
              { campaign_id: campaignId },
              {
                params: data,
              }
            )
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              email: basicEmailText,
              first_name: basicText,
              last_name: basicText,
              redirect_url: basicUrlText
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data.data,
            count: data.total,
          };
        },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: [],
        filterable: [],
        headings: {
          first_name: this.$t('frontend_resource_promo_first_name'),
          last_name: this.$t('frontend_resource_promo_last_name'),
          email: this.$t('frontend_resource_promo_email'),
          redirect_url: this.$t('frontend_groovemail_contacts_step2_url'),
        },
        rowClassCallback() {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
    };
  },

  created(){
    self = this;
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
  },

  components: {
    VuePerfectScrollbar,
  },

  methods: {
    // Triggers emitting event to indicate data has started loading.
    showLoader() {
      this.$emit('showLoader');
    },

    // Triggers emitting event to indicate data has loaded.
    hideLoader() {
      this.$emit('hideLoader');
    },
  },
};
</script>
